import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormControl, FormGroup, NgForm } from '@angular/forms';

import { Router, ActivatedRoute } from '@angular/router';

import axios from "src/app/Service/axios";

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';

declare let $: any;

import * as XLSX from 'xlsx';

@Component({

  selector: 'app-tanker-list',

  templateUrl: './tanker-list.component.html',

  styleUrls: ['./tanker-list.component.css']

})

export class TankerListComponent implements OnInit {

  list_Tanker: any = [];

  list_Search = [];

  list_MaterialType = [];

  tankerInfo: any = [];

  isLoading: boolean = false;

  bTanker_Edit: boolean = false;

  bTankerReport: boolean = false;

  bTankerSource: boolean = false;

  bBaseTanker: boolean = false;

  totalfCapacity: number = 0

  totalfVolume: number = 0

  totalfEmptyCapacity: number = 0;

  totalCount: number = 0;

  sourceModel: FormGroup = this.FormBuilder.group({

    strSDate: new FormControl(''),

    strEDate: new FormControl(''),

    iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)

  })

  constructor(private otherService: OtherService, private FormBuilder: FormBuilder, private ActivatedRoute: ActivatedRoute, private router: Router, private gurdService: GurdServiceService, private Notification: NotificationService) { }

  ngOnInit(): void {

    this.ActivatedRoute.url.subscribe((segment) => {

      if (segment[0].path == 'Report') this.bTankerReport = true;

      if (segment[0].path == 'base-Source') this.bTankerSource = true;

      if (segment[0].path == 'base-Tanker') this.bBaseTanker = true;

      if (!this.bTankerSource && !this.bBaseTanker) this.getTanker();

      if (!this.bTankerReport && !this.bTankerSource && !this.bBaseTanker) this.bTanker_Edit = JSON.parse(this.gurdService.decrypt(localStorage.getItem('menu') as any)).bTanker_Edit;

    })

  }

  async getTanker() {

    // this.isLoading = true;

    this.otherService.Showspinner()

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    }

    let url = this.bTankerReport ? 'Tanker_Report_TankerStatus' : 'Tanker_List';

    let res = JSON.parse((await axios.post(url, model)).data.toString());

    // this.isLoading = false;

    this.otherService.nonespinner()

    this.list_Tanker = res;

    this.list_Search = res;

    res.forEach((a: any) => {

      this.totalfCapacity += a.fCapacity

      this.totalfVolume += a.fVolume

      this.totalfEmptyCapacity += a.fEmptyCapacity

    })

    if (!this.bTankerReport) {

      let res_2 = JSON.parse((await axios.post(`MaterialType_List`, model)).data.toString());

      this.list_MaterialType = res_2;

    }

  }

  async getTankerBySource() {

    this.totalfCapacity = 0;

    this.totalCount = 0;

    this.otherService.Showspinner()

    let url = this.bTankerSource ? 'Tanker_Report_Feeding_Statistics' : 'Tanker_Report_Feeding_TankerStatistics';

    let res = JSON.parse((await axios.post(url, this.sourceModel.value)).data.toString());

    this.otherService.nonespinner()

    this.list_Tanker = res;

    this.list_Search = res;

    res.forEach((a: any) => {

      this.totalfCapacity += a.fFeedingValue

      this.totalCount += a.iCount

    })

  }

  formatted_pelak(strVehicle: any) {

    return strVehicle != undefined ? `ایران ${strVehicle.split(' ')[4]} | ${strVehicle.split(' ')[2]} ${strVehicle.split(' ')[1]} ${strVehicle.split(' ')[0]}` : '';

  }

  openEditModal(item: any) {

    item.ffCapacity = item.fCapacity.toString().trim().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

    item.iTankWidth = item.iTankWidth.toString().trim().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    item.iTankLength = item.iTankLength.toString().trim().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    this.tankerInfo = item;

    $('#editModal').modal('show');

  }

  editTankerItem(form: NgForm) {

    if (form.invalid) return this.Notification.showError('لطفا فرم را با دقت تکمیل کنید');

    form.value.iSystemUser = this.gurdService.decrypt(localStorage.getItem('ID')!);

    form.value.strSession = this.gurdService.decrypt(localStorage.getItem('Session')!);

    form.value.strUnitID = this.tankerInfo.strUnitID;

    form.value.ffCapacity = form.value.ffCapacity.toString().replace(/,/g, '');

    form.value.iTankWidth = form.value.iTankWidth.toString().replace(/,/g, '');

    form.value.iTankLength = form.value.iTankLength.toString().replace(/,/g, '');

    $.confirm({

      title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

      content: '',

      type: 'blue',

      buttons: {

        ok: {

          text: "ویرایش",

          btnClass: 'btn-primary',

          keys: ['enter'],

          action: async () => {

            // this.isLoading = true;

            this.otherService.Showspinner()

            let res = JSON.parse((await axios.post(`Tanker_Update`, form.value)).data.toString())[0];

            const index = this.list_Tanker.indexOf(this.tankerInfo);

            if (index != -1) this.list_Tanker[index] = res;

            this.totalfCapacity = 0;

            this.totalfVolume = 0;

            this.totalfEmptyCapacity = 0

            this.list_Tanker.forEach((a: any) => {

              this.totalfCapacity += a.fCapacity

              this.totalfVolume += a.fVolume

              this.totalfEmptyCapacity += a.fEmptyCapacity

            })


            this.Notification.showSuccess('با موفقیت ویرایش شد');

            $(`#editModal`).modal('hide');

            this.otherService.nonespinner()

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

  searchBy(search: any) {

    if (search.length > 2) {

      this.list_Tanker = this.list_Search.filter((el: any) => {

        return el.strFullName.includes(search) || el.strCellNo.toString().includes(search) || el.strMaterialType_strComment.includes(search) || el.strMobileDomain_strComment.includes(search)

      })
    }

    else if (search == '') this.list_Tanker = this.list_Search
  }

  goBack() {

    this.router.navigateByUrl(`/`);;

  }

  exportExcel(): void {

    let fileName = this.bTankerReport ? ' گزارش وضعیت تانکر ها  ' : this.bTankerSource ? 'گزارش شرح تامین به تفکیک منبع ' : this.bBaseTanker ? 'گزارش شرح تامین به تفکیک تانکر ' : 'شناسنامه تانکر';

    let element = document.getElementById('Export_Excel');

    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    const wb: XLSX.WorkBook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    XLSX.writeFile(wb, `${fileName}.xlsx`);

  }


}
